import React from 'react';
import { JobT } from '../../../../../types/Job';
import Invoice from '../Invoice/Invoice';

export type IReceiptProps = {
    company: any
    job: JobT
    jobOrigin: JobT
    updateJob(key: string, value: any): void
    updateDocument(key: string, value: any): void
    isActive: boolean
}

const Receipt: React.FC<IReceiptProps> = (props) => {
    return (
        <Invoice {...props} isReceipt={true} />
    );
}

export default Receipt